<span
  class="order-status"
  [title]="orderStatusName"
  [ngClass]="orderStatusClass"
>
  <span [textContent]="orderStatusName"> </span>
</span>
